import AppSettings from '../AppSettings';

import {hasSomeParentTheClass, addMultiEvents} from '../../core/utils';

export default class EmailCaptureHelper {

	constructor(parentElement, templateMessages, opts = {}) {

		this.emailContainer = parentElement;
		this.emailElements = [];
		const passthrough = [];
		this.templateMessages = templateMessages;


		function _getPassthroughField(name) {

			if (typeof passthrough !== 'undefined') {

				return (name.toLowerCase() in passthrough) ? passthrough[name.toLowerCase()] : "";

			} else {

				return "";
			}
		}

		function _regexOnly(e) {
			const reg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return reg.test(this.value);
		}

		function _createFieldset(fieldName, name){
			const wrapperDiv = document.createElement('div');
			wrapperDiv.classList.add('email-capture-item', 'form-group');

			const inputfield = document.createElement('input');
			inputfield.type = "email";
			inputfield.id = fieldName;
			inputfield.classList.add('input-transition-effect', 'textbox1', 'emailElement');
			inputfield.name = fieldName;
			inputfield.isValid = _regexOnly;

			const divValidation = document.createElement('div');
			divValidation.className = "validation";
			divValidation.innerHTML = "*";	
			
			const fieldLabel = document.createElement('label');
			fieldLabel.setAttribute("for",fieldName);
			fieldLabel.innerHTML = name;	

			const msgDiv = document.createElement('div');
			msgDiv.className = "msg-div";

			// Restrict copy paste drag drop from Email textboxes
			document.addEventListener("DOMContentLoaded", function(){
				addMultiEvents(inputfield, 'cut copy paste drag drop', function(e){
					e.preventDefault();
				});
			});

			const pass = _getPassthroughField("emailaddress");
			if ( pass != "") inputfield.value = pass;
			
			wrapperDiv.appendChild(inputfield);
			wrapperDiv.appendChild(fieldLabel);
			wrapperDiv.appendChild(divValidation);
			wrapperDiv.appendChild(msgDiv);

			return wrapperDiv;
		}

		//entry point
		this.emailContainer.appendChild(_createFieldset('email', this.templateMessages.email.label));
		this.emailContainer.appendChild(_createFieldset('confirm_email', this.templateMessages.email.confirmlabel));

	}

	getEmailValue(isPassthrough) {
		const el = this.emailContainer.querySelector('#email');
		const value = el.value;
		// const flag = isPassthrough ? el.returnOnHandback : true;
		// if (flag) {
		// 	values[el.getAttribute("id")] = val;
		// }

		/* Assigning values to main object which gets used in final card submission */
		AppSettings.client.EmailAddress = value;

		return value;
	};

	getValidations(e) {
		const el = e ? e.currentTarget : undefined;
		return this.validateFields(el);
	};

	validateFields(el) {
		const activeInput = el;
		const messages = [];
		let j = 0;
		const inputEmail = this.emailContainer.querySelector('#email');
		const inputConfEmail = this.emailContainer.querySelector('#confirm_email');

	 	// On focusout event on input
		if(activeInput != undefined) {

			// CASE 1: input is empty
			if (activeInput.value === ""){
				messages[j] = this.templateMessages.email.mandatory;
				this.performValidations_UI(activeInput, messages[j]);
				j++;
			}

			// CASE 2: input is not valid
			else if (!activeInput.isValid()){
				messages[j] = this.templateMessages.email.invalid;
				this.performValidations_UI(activeInput, messages[j]);
				j++;
			}

			// CASE 3: both inputs are valid, then compare both inputs
			else if (inputEmail.isValid() && inputConfEmail.isValid()){
				if(inputEmail.value !== inputConfEmail.value){
					messages[j] = this.templateMessages.email.nomatch;
					this.performValidations_UI(inputEmail, '');
					this.performValidations_UI(inputConfEmail, messages[j]);
				}
				else {
					this.performValidations_UI(inputEmail, '');
					this.performValidations_UI(inputConfEmail, '');
				}
			}

			// Case 4: No Error
			else {
				this.performValidations_UI(activeInput, '');
			}
		}
		
		// On click of submit button
		else {
			this.removeAllValidations();
			const inputEmail = this.emailContainer.querySelector('#email');
			const inputConfEmail = this.emailContainer.querySelector('#confirm_email');
			
			// CASE 1: email is valid AND confEmail is empty
			if (inputEmail.isValid() && inputConfEmail.value === ""){
				messages[j] = this.templateMessages.email.mandatory;
				this.performValidations_UI(inputConfEmail, messages[j]);
				j++;
			}

			// CASE 2: email is empty OR confEmail is empty
			else if (inputEmail.value === "" || inputConfEmail.value === ""){
				messages[j] = this.templateMessages.email.mandatory;
				this.performValidations_UI(inputEmail, messages[j]);
				this.performValidations_UI(inputConfEmail, messages[j]);
				j++;
			}

			// CASE 3: email is valid AND confEmail is not valid
			else if (inputEmail.isValid() && !inputConfEmail.isValid()){
				messages[j] = this.templateMessages.email.invalid;
				this.performValidations_UI(inputConfEmail, messages[j]);
				j++;
			}
			
			// CASE 4: email is not valid OR confEmail is not valid
			else if (!inputEmail.isValid() || !inputConfEmail.isValid()){
				messages[j] = this.templateMessages.email.invalid;
				this.performValidations_UI(inputEmail, messages[j]);
				this.performValidations_UI(inputConfEmail, messages[j]);
				j++;
			}

			// CASE 5: email is valid AND confEmail is valid AND email is not equal to confEmail
			else if (inputEmail.isValid() && inputConfEmail.isValid() && inputEmail.value !== inputConfEmail.value){
				messages[j] = this.templateMessages.email.nomatch;
				this.performValidations_UI(inputEmail, messages[j]);
				this.performValidations_UI(inputConfEmail, messages[j]);
				j++;
			}
		}

		return messages;
	};

	performValidations_UI(el, message) {
		const field_item = hasSomeParentTheClass(el, 'form-group');
		
		/* class toggle for Floating Label UI */
		if(el.value === '') {
			el.classList.remove("has-content");
		}
		else {
			el.classList.add("has-content");
		}

		if(message === undefined || message === '') {
			field_item.classList.remove('error-input-wrap');
		}
		else {
			field_item.classList.add('error-input-wrap');
			field_item.querySelector('.msg-div').innerHTML = message;
		}
	}

	removeAllValidations() {
		const field_msg = this.emailContainer.querySelectorAll(".msg-div");
		[].forEach.call(field_msg, function(el) {
			el.innerHTML = "";
		});

		const field_item = this.emailContainer.querySelectorAll(".form-group");
		[].forEach.call(field_item, function(el) {
			el.classList.remove('error-input-wrap');
		});
	};
	
}
